import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/**
 * What a leader told us while registering a group, used to tailor the group's
 * onboarding. Only kept in this browser session; nothing here is sent to the API.
 */
export type OnboardingPrefs = {
  /** The leader's own answer; an age verified with BankID takes precedence */
  isAdult?: boolean;
  /** From the website's profit calculator, when the leader came from there */
  participantCount?: number;
  itemsPerParticipant?: number;
};

type OnboardingPrefsStore = {
  byGroup: Record<string, OnboardingPrefs>;
  setPrefs: (groupId: string, prefs: OnboardingPrefs) => void;
};

export const useOnboardingPrefsStore = create<OnboardingPrefsStore>()(
  persist(
    (set) => ({
      byGroup: {},
      setPrefs: (groupId, prefs) =>
        set((state) => ({ byGroup: { ...state.byGroup, [groupId]: { ...state.byGroup[groupId], ...prefs } } })),
    }),
    {
      name: 'piggo:onboarding-prefs',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

const EMPTY_PREFS: OnboardingPrefs = {};

export const useOnboardingPrefs = (groupId: string | undefined) =>
  useOnboardingPrefsStore((state) => (groupId && state.byGroup[groupId]) || EMPTY_PREFS);
